export enum requestType {
    METHOD_GET = 1,
    METHOD_POST = 2,
    METHOD_PUT = 3,
    METHOD_GET_PARAMS = 4,
    METHOD_PATCH = 5,
    METHOD_POST_BLOB = 6,
    METHOD_DELETE = 7,
    METHOD_GET_HEADER = 8,
    METHOD_GET_BLOB_JSON = 9
}